export default __webpack_public_path__ + "static/media/hoseg1.c6158ce8.jpg";